
import { useState } from 'react';

export default function Pricing() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleJoinClick = () => {
    setIsModalOpen(true);
  };

  const handleAgentClick = () => {
    const agentButton = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (agentButton) {
      agentButton.click();
    }
  };

  return (
    <>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              간단하고 합리적인 회비
            </h2>
            <p className="text-xl text-gray-600">
              매주 철학 자료와 함께 성장하세요
            </p>
          </div>

          <div className="max-w-lg mx-auto">
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 shadow-xl border-2 border-blue-200">
              <div className="text-center">
                <div className="mb-6">
                  <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    추천 플랜
                  </span>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-800 mb-2">
                  철학 교육 프로그램
                </h3>
                
                <div className="mb-6">
                  <span className="text-5xl font-bold text-blue-600">2,990</span>
                  <span className="text-xl text-gray-600 ml-2">원/월</span>
                </div>

                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                    <span className="text-gray-700">매주 철학 자료 제공</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                    <span className="text-gray-700">자기개발 콘텐츠</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                    <span className="text-gray-700">리더십 개발 프로그램</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                    <span className="text-gray-700">솔로몬의 지혜 학습</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-green-500 text-xl mr-3"></i>
                    <span className="text-gray-700">개인별 맞춤 피드백</span>
                  </div>
                </div>

                <div className="space-y-3">
                  <button
                    onClick={handleJoinClick}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 rounded-xl font-semibold text-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-user-add-line mr-2"></i>
                    지금 시작하기
                  </button>
                  
                  <button
                    onClick={handleAgentClick}
                    className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-xl font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-question-line mr-2"></i>
                    궁금한 점 문의하기
                  </button>
                </div>

                <p className="text-sm text-gray-500 mt-6">
                  * 첫 달 무료 체험 가능<br />
                  * 언제든지 해지 가능
                </p>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <div className="bg-yellow-50 rounded-2xl p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                특별 혜택
              </h3>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-gift-line text-2xl text-yellow-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">첫 달 무료</h4>
                  <p className="text-sm text-gray-600">프로그램을 체험해보세요</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-group-line text-2xl text-green-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">친구 추천 할인</h4>
                  <p className="text-sm text-gray-600">친구와 함께 50% 할인</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-medal-line text-2xl text-blue-600"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 mb-2">우수 학생 장학금</h4>
                  <p className="text-sm text-gray-600">성실한 참여자에게 혜택</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Join Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full">
            <div className="p-6 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-information-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">
                회원가입 안내
              </h3>
              <p className="text-gray-600 mb-6">
                회원가입은 상단의 "지금 회원가입하기" 버튼을 통해 진행하실 수 있습니다.<br />
                또는 우측 하단의 채팅 상담을 통해 문의해주세요.
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-lg font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  닫기
                </button>
                <button
                  onClick={handleAgentClick}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  상담하기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
